import React from 'react';
import MessagesView from './messages-view.jsx';

export default function ChatRoomView(props) {
  return <MessagesView { ...props } />;
}
